import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import List from '@material-ui/core/List'

import { qlpMenuItems } from "../../routes";

import NavMenuItem from "../common/NavItems/NavMenuItem";

const drawerWidth = 240;

const useStyles = makeStyles((theme) =>
    createStyles({
        appMenu: {
            width: "100%"
        },
        navList: {
            width: drawerWidth
        },
        menuItem: {
            width: drawerWidth
        },
        menuItemIcon: {
            color: "#00a650"
        }
    })
);


const QlpMenu = () => {
    const classes = useStyles();

    return (
        <List component="nav" className={classes.appMenu} disablePadding>
            {/* <AppMenuItem {...appMenuItems[0]} /> */}
            {qlpMenuItems.map((item, index) => (
                <NavMenuItem {...item} key={index} />
            ))}

        </List>
    );

}

export default QlpMenu;
